import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
    getCycleDropDownSuccessAction,
    getCycleDropDownFailureAction,
    getCycleReportSuccessAction,
  getCycleReportFailureAction,
  getCycleExportFileSuccessAction,
  getCycleExportFileFailureAction
} from '../../features/Reports/cycleReportSlice';
import URLs from '../../../constants/urls';
import { GET_CYCLE_REPORT_DROP_DOWN, GET_CYCLE_REPORT_TABLE_DATA, GET_CYCLE_EXPORT_FILE } from '../../actions/Reports/actionCycleTypes';
import { apiPython } from '../../../service/api';
const api = apiPython;
import { getSessionStorage } from '../../../utils/helpers';
export function* getDropDownListSaga() {
  try {
    const response = yield api.get(URLs.GET_CYCLE_DROPDOWN_VALUE);
    yield put(getCycleDropDownSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCycleDropDownFailureAction(error));
  }
}
export function* getCycleReportListSaga({ payload: data }) {
  try {
    const response = yield api.get(`${URLs.GET_CYCLE_COMPARE}?compareCycleID1=${data['id1']}&compareCycleID2=${data['id2']}&loggedUserID=${getSessionStorage('USER_ID')}&permissionlevel=${getSessionStorage('PERMISSION_LEVEL')}`);
    yield put(getCycleReportSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCycleReportFailureAction(error));
  }
}
export function* getExportFileSaga({ payload: data }) {
  try {
    const response = yield api.get(`${URLs.GET_EXPORT_DOWNLOAD_COMPARE}?compareCycleID1=${data['id1']}&compareCycleID2=${data['id2']}&loggedUserID=${getSessionStorage('USER_ID')}&permissionlevel=${getSessionStorage('PERMISSION_LEVEL')}`);
    yield put(getCycleExportFileSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCycleExportFileFailureAction(error));
  }
}
export function* watchReport() {
  yield takeEvery(GET_CYCLE_REPORT_DROP_DOWN, getDropDownListSaga);
  yield takeEvery(GET_CYCLE_EXPORT_FILE, getExportFileSaga);
  yield takeEvery(GET_CYCLE_REPORT_TABLE_DATA, getCycleReportListSaga);
}

export default function* cycleReportSaga() {
  yield all([watchReport()]);
}

